import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { first, tap } from 'rxjs';
import { ProjectFormModel } from 'src/app/core/models/project/project-form.model';
import { ProjectForUpsert } from 'src/app/core/models/project/project.model';
import { ProjectService } from 'src/app/core/services/project.service';
import { Util } from 'src/app/core/utils/util';

@Component({
  selector: 'app-add-project',
  imports: [TranslateModule, ReactiveFormsModule],
  templateUrl: './add-project.component.html',
  styleUrl: './add-project.component.scss',
  standalone: true,
  providers: [ProjectFormModel],
})
export class AddProjectComponent {
  projectFormModel = inject(ProjectFormModel);
  private readonly projectService = inject(ProjectService);

  @Input({ required: true })
  public companyId!: string;

  @Input({ required: true })
  public organizationId!: string;

  @Output() public cancelled = new EventEmitter<void>();
  @Output() public created = new EventEmitter<string>();

  public titleFormControl: AbstractControl | null;

  constructor() {
    this.titleFormControl = this.projectFormModel.form.controls.title;
  }

  public addProject(): void {
    this.projectService.setProjectsUrl(this.companyId);

    const project: ProjectForUpsert = {
      id: Util.generateGUID(),
      title: this.titleFormControl!.value,
      organizationId: this.organizationId,
      employeesIds: [],
    };

    this.projectService
      .createProject(project)
      .pipe(
        first(),
        tap(createdProjectId => this.created.emit(createdProjectId)),
      )
      .subscribe();
  }

  public onCancel(): void {
    this.cancelled.emit();
  }
}
